import { render, staticRenderFns } from "./derate.vue?vue&type=template&id=3c29ac28&scoped=true&"
import script from "./derate.vue?vue&type=script&lang=js&"
export * from "./derate.vue?vue&type=script&lang=js&"
import style0 from "./derate.vue?vue&type=style&index=0&id=3c29ac28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29ac28",
  null
  
)

export default component.exports